import { FC } from 'react';
import { useNavigation } from '@refinedev/core';
import { Button } from '../button';
import { AppstoreOutlined } from '@ant-design/icons';

type ListButtonProps = {
    resource?: string;
    label?: string;
    icon?: React.ReactNode;
    variant?: 'primary' | 'secondary' | 'small';
};

export const ListButton: FC<ListButtonProps> = ({
    resource = 'applications',
    label = '',
    icon = <AppstoreOutlined />,
    variant = 'small',
}) => {
    const { list } = useNavigation();

    return (
        <Button icon={icon} onClick={() => list(resource)} variant={variant}>
            {label}
        </Button>
    );
};
